import title from '../video_assets/Maus-tanzt.png'

const url =
  'https://wdradaptiv-vh.akamaihd.net/i/medp/ondemand/weltweit/fsk0/245/2459045/,2459045_35926714,2459045_35926715,2459045_35926716,2459045_35926712,2459045_35926717,2459045_35926713,.mp4.csmil/master.m3u8'

export default {
  id: '04',
  name: 'Stopptanz (Musik 4/5)',
  subtitle: 'Die Maus gibt den Takt an beim Stopptanz',
  image: title,
  video: url,
}
